import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
import Pagination from "react-js-pagination";
import { SideBar } from '../Common/SideBar';
import Chat from '../../Models/Chat';
import Notifications from '../../Models/Notifications';
import { Badge } from 'reactstrap';
class SellerBuyerDirectMessageList extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            activePage: 1,
            user: logged_user.id,
            openningStatus: '',
            openningStatusButton: '',
            openningStatusButtonAdmin: '',
            thread: [],
            payload: [],
        }
        this.getMessageNotification();
    };
    componentDidMount() {
        window.scrollTo(0, 0);
        Chat.getThreadsBuyer(this.state.user).then(res => {
            this.setState({ thread: res.data.payload })
        })
    }

    getMessageNotification() {
        Notifications.getAllMessage(this.state.user).then(res => {
            res.data.text.map(res => {
                if (this.state.user == res.buyer_id) {
                    this.setState({ openningStatus: res.opening_status_receiver, buyerID: res.buyer_id })
                } else if (res.buyer_id == 0) {
                    if (res.opening_status_receiver == 'Unread') {
                        this.setState({ openningStatusButtonAdmin: res.opening_status_receiver })
                    }
                } else {
                    if (res.opening_status_receiver == 'Unread') {
                        this.setState({ openningStatusButton: res.opening_status_receiver })
                    }
                }
            })
            this.setState({ payload: res.data.text })
        })
    }

    openMessageStatus(receiverid, senderId) {
        console.log(receiverid, senderId)
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.openMessageStatus(receiverid, senderId).then(res => {
                console.log(res.data)
                if (res.data.payload !== null) {
                    this.setState({ unreadStatus: res.data.payload })
                }
            })
            this.getMessageNotification();
        }
    }


    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }

    messageNotificationBadge(id, buyerId, i, status) {
        if (this.state.user == id) {
            if (buyerId == i) {
                if (status == 'Unread') {
                    return (
                        <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', fontSize: '18px', marginTop: '4px' }} ><i class="fas fa-exclamation-circle"></i></Badge>
                    )
                }
            }
        }
    }

    messageNotificationBadgeButton() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.openningStatusButton === 'Unread')
                return (
                    <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', fontSize: "18px", position: 'absolute', zIndex: '100', marginLeft: "8px" }} color="danger"><i class="fas fa-exclamation-circle"></i></Badge>
                )
        } else {
            if (this.state.openningStatusButton === 'Unread')
                return (
                    <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', fontSize: "18px", position: 'absolute', zIndex: '100', marginTop: '3px', marginLeft: "-5px" }} color="danger"><i class="fas fa-exclamation-circle"></i></Badge>
                )
        }
    }

    messageNotificationBadgeAdmin() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.openningStatusButtonAdmin === 'Unread')
                return (
                    <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', position: 'absolute', zIndex: '100', marginTop: '-8px', marginLeft: "5px" }} ><i class="fas fa-exclamation-circle"></i></Badge>
                )
        } else {
            if (this.state.openningStatusButtonAdmin === 'Unread')
                return (
                    <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', position: 'absolute', zIndex: '100', marginTop: '-8px', marginLeft: "-5px" }}><i class="fas fa-exclamation-circle"></i></Badge>
                )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className=" mt-5  input_name big_font  " style={{ width: '100%', fontSize: '20px', textAlign: 'left' }}>
                                    <div className="row">
                                        <div className="col-9" style={{ fontSize: '16px' }}>
                                            <span>販売者からメッセージ</span>
                                        </div>
                                        <div className="col-3" style={{ paddingBottom: "5px", textAlign: "right" }} onClick={this.openMessageStatus.bind(this, this.state.user, 0)} >
                                            <div className="pr-3">
                                                {this.messageNotificationBadgeAdmin()}
                                            </div>
                                            <Link to={'/com-with-sys'} >
                                                <img src={require('../../assets/images/admin.png')} className=" rounded-circle" alt="" width="30" height="30" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="message_show_box" style={{ minHeight: '475px' }}>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="navigation col-6" style={{ fontSize: '12px', padding: '10px' }}>
                                                <Link to={'/seller-direct-message-list'} className="h-a" href="">購入者からメッセージ</Link>
                                                {this.messageNotificationBadgeButton()}
                                            </div>
                                            <div className="navigation col-6" style={{ borderBottom: "4px solid #67b1e2", bordertop: "1px solid white", fontSize: '12px', padding: '10px' }}>
                                                <Link to={'/seller-buyer-direct-message-list'} className="h-a" href="">販売者からメッセージ</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="message_box m-2 mt-4 p-2" >
                                        {this.state.thread.map(th =>
                                            <div onClick={this.openMessageStatus.bind(this, th.buyer_id, th.seller_id)}>
                                                <Link to={{
                                                    pathname: '/seller-direct-message',
                                                    state: {
                                                        buyer_id: th.buyer_id,
                                                        seller_id: th.seller_id
                                                    }
                                                }}>
                                                    <div className="row">
                                                        <div className="col-3">
                                                            <img src={th.img_buyer} className=" rounded-circle" alt="" width="50" height="50" style={{ zIndex: '200', position: 'relative' }} /><br />
                                                        </div>
                                                        <div className="col-7">
                                                            <div className="message_name_text">
                                                                <span><b>{th.first_name}</b></span>
                                                            </div>
                                                            <span style={{ fontSize: "10px" }}>{(JSON.stringify(th.created_at)).substring(1, 11)}</span>
                                                        </div>
                                                        <div className="col-2">
                                                            {this.state.payload.map(res =>
                                                                this.messageNotificationBadge( res.buyer_id,th.seller_id,res.sender_id,res.opening_status_receiver)
                                                            )}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                    {/* <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-7 ">
                                                <Pagination
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={10}
                                                    totalItemsCount={450}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handlePageChange.bind(this)}
                                                />
                                            </div>
                                            <div className="col-md-2"></div>
                                        </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font  row" style={{ textAlign: "left", width: "100%", marginLeft: '0px' }}>
                                            <div className="col-md-9" style={{ paddingLeft: '0px' }}>
                                                <span>販売者からメッセージ</span>
                                            </div>
                                            <div className="col-md-3" style={{ paddingBottom: "5px", textAlign: "right" }} onClick={this.openMessageStatus.bind(this, this.state.user, 0)}>
                                                <Link to={'/com-with-sys'}>
                                                    <button style={{ borderRadius: "4px", padding: "2%", fontSize: "15px" }}>管理者メッセージ</button>
                                                    {this.messageNotificationBadgeAdmin()}
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="message_show_box">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="navigation col-md-6" >
                                                        <div className="" style={{ paddingLeft: '220px' }}>
                                                            {this.messageNotificationBadgeButton()}
                                                        </div>
                                                        <Link to={'/seller-direct-message-list'} className="h-a" href="" >購入者からメッセージ</Link>
                                                    </div>
                                                    <div className="navigation col-md-6" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white" }}>
                                                        <Link to={'/seller-buyer-direct-message-list'} className="h-a" href="">販売者からメッセージ</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="message_box m-2 mt-4 p-2" >
                                                {this.state.thread.map(th =>
                                                    <div onClick={this.openMessageStatus.bind(this, th.buyer_id, th.seller_id)}>
                                                        <Link to={{
                                                            pathname: '/seller-direct-message',
                                                            state: {
                                                                buyer_id: th.buyer_id,
                                                                seller_id: th.seller_id
                                                            }
                                                        }}>
                                                            <div className="row">
                                                                <div className="col-md-2 mini_pad">
                                                                    <img src={th.img_buyer} className=" rounded-circle" alt="" width="70" height="70" /><br />
                                                                </div>
                                                                <div className="col-md-7 mt-3">
                                                                    <div className="message_name_text">
                                                                        <span><b>{th.first_name}</b></span><br />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2 mt-3">
                                                                    <span style={{ fontSize: "13px" }}>{(JSON.stringify(th.created_at)).substring(1, 11)}</span>
                                                                </div>
                                                                <div className="col-md-1 mt-3">
                                                                    {this.state.payload.map(res =>
                                                                        this.messageNotificationBadge( res.buyer_id,th.seller_id,res.sender_id,res.opening_status_receiver)
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <hr />
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>

                                            {/* <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-7 ">
                                                <Pagination
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={10}
                                                    totalItemsCount={450}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handlePageChange.bind(this)}
                                                />
                                            </div>
                                            <div className="col-md-2"></div>
                                        </div> */}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
    }
}
export { SellerBuyerDirectMessageList }